<!--
 * @Author: lishiqiao
 * @Date: 2021-12-22 09:52:28
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-10-26 12:01:39
-->
<template>
  <div class="product">
    <ContentBox
      class="contactus-content-box news-detail-box"
      :title="productDetail.show ? productDetail.title : $t('product.title')"
    >
      <div class="product_detail_html" v-show="productDetail.show">
        <div class="new-detail-main">
          <div class="out-detail">
            <div class="out-img-box" @click="productDetailCancel">
              <svg
                @click="productDetailClose()"
                version="1.1"
                id="图层_2"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 44.9 42.3"
                style="enable-background: new 0 0 44.9 42.3"
                xml:space="preserve"
              >
                <g>
                  <image
                    style="overflow: visible; opacity: 0.2"
                    width="57"
                    height="58"
                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA7CAYAAAAq55mNAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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"
                    transform="matrix(1 0 0 1 -4.9782 -7.0512)"
                  ></image>
                  <g>
                    <path
                      class="st0"
                      d="M34.7,28.6l-7.5-7.5l7.5-7.5c1.3-1.3,1.3-3.5,0-4.8l0,0c-1.3-1.3-3.5-1.3-4.8,0l-7.5,7.5l-7.5-7.5
			c-1.3-1.3-3.5-1.3-4.8,0l0,0c-1.3,1.3-1.3,3.5,0,4.8l7.5,7.5l-7.5,7.5c-1.3,1.3-1.3,3.5,0,4.8l0,0c1.3,1.3,3.5,1.3,4.8,0l7.5-7.5
			l7.5,7.5c1.3,1.3,3.5,1.3,4.8,0l0,0C36.1,32.1,36.1,29.9,34.7,28.6z"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="detail_box">
            <div
              class="detail-content"
              ref="detail_content_ref"
              v-lazy-container="{ selector: 'img' }"
              v-html="$options.filters.OSSUrl(productDetail.detail)"
            ></div>
            <div class="product_btn" @click="onLineClick">
              {{ $t("product.consult_now") }}
            </div>
          </div>
        </div>
      </div>
      <el-tabs
        v-show="!productDetail.show"
        v-model="topActiveName"
        @tab-click="topHandleClick"
      >
        <!-- 产品介绍 -->
        <el-tab-pane
          :label="$t('product.product_introduce')"
          name="topFirst"
          class="topFirst"
        >
          <div ref="content1" class="product_introduce_content">
            <div
              class="product_item_content"
              :key="i"
              v-for="(item, i) in productDescriptionList"
            >
              <div class="product_img" @click.stop="productDetailClick(item)">
                <img :src="$options.filters.OSSUrl(item.mainPicture)" alt="" />
                <div
                  class="img_detail_click"
                  @click.stop="productDetailClick(item)"
                >
                  {{ $t("product.view_details") }}
                </div>
              </div>
              <div class="product_btn" @click="onLineClick">
                {{ $t("product.consult_now") }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- U鱼智慧渔业管理平台 -->
        <el-tab-pane
          :label="$t('product.platform')"
          name="topSecond"
          class="topSecond"
        >
          <el-carousel
            :indicator-position="platformIndicator"
            arrow="never"
            :autoplay="false"
            trigger="click"
            ref="noptopSecond"
          >
            <el-carousel-item
              v-for="(item, i) of platformPageSize"
              :key="item + i"
            >
              <el-tabs
                v-model="platformLeftActiveName"
                @tab-click="leftHandleClick('topSecond')"
                tab-position="left"
              >
                <el-tab-pane
                  v-for="item1 of platformInformationTileList[i]"
                  :key="item1"
                  :label="item1"
                  :name="item1"
                ></el-tab-pane>
              </el-tabs>
            </el-carousel-item>
          </el-carousel>
          <div ref="content2" class="product-content">
            <div class="product-box">
              <div
                class="product-img"
                v-if="platformDetailsData.detailPicture1"
              >
                <img :src="platformDetailsData.detailPicture1" lazy-load />
                <img :src="platformDetailsData.detailPicture2" lazy-load />
              </div>
              <div
                v-if="platformDetailsData.details"
                class="product-details"
                v-lazy-container="{ selector: 'img' }"
                v-html="$options.filters.OSSUrl(platformDetailsData.details)"
              ></div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 使用教程 -->
        <el-tab-pane
          :label="$t('product.tutorial')"
          name="topThird"
          class="topThird"
        >
          <el-carousel
            :indicator-position="useIndicator"
            arrow="never"
            :autoplay="false"
            trigger="click"
            ref="noptopThird"
          >
            <el-carousel-item v-for="(item, i) of usePageSize" :key="item + i">
              <el-tabs
                v-model="useLeftActiveName"
                @tab-click="leftHandleClick('topThird')"
                tab-position="left"
              >
                <el-tab-pane
                  v-for="item1 of useTutorialTileList[i]"
                  :key="item1"
                  :label="item1"
                  :name="item1"
                ></el-tab-pane>
              </el-tabs>
            </el-carousel-item>
          </el-carousel>
          <div ref="content3" class="product-content">
            <div class="use-detailsVideo">
              <video
                v-if="useTutorialDetailsData.detailsVideo"
                ref="detailsVideo"
                :src="useTutorialDetailsData.detailsVideo | OSSUrl"
                lazy-load
              >
                您的浏览器不支持播放视频。
              </video>
              <svg
                v-if="useTutorialDetailsData.detailsVideo"
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 500 500"
                style="enable-background: new 0 0 500 500"
                xml:space="preserve"
                @click="playVideo"
                :class="videoState === 'play' ? 'video-play' : 'video-stop'"
              >
                <linearGradient
                  id="SVGID_1_"
                  gradientUnits="userSpaceOnUse"
                  x1="250"
                  y1="458.8044"
                  x2="250"
                  y2="-65.0971"
                >
                  <stop offset="0" style="stop-color: #045cd2" />
                  <stop offset="1" style="stop-color: #4bdaff" />
                </linearGradient>
                <path
                  class="st0"
                  d="M250,69.5c48.2,0,93.5,18.8,127.6,52.9s52.9,79.4,52.9,127.6s-18.8,93.5-52.9,127.6s-79.4,52.9-127.6,52.9
	s-93.5-18.8-127.6-52.9S69.5,298.2,69.5,250s18.8-93.5,52.9-127.6S201.8,69.5,250,69.5 M250,63.5C147,63.5,63.5,147,63.5,250
	S147,436.5,250,436.5S436.5,353,436.5,250S353,63.5,250,63.5L250,63.5z M217.6,174.4c1.8,0,3.6,0.6,5.1,1.7l92.5,66.7
	c2.3,1.7,3.7,4.3,3.7,7.2s-1.3,5.5-3.7,7.2l-92.5,66.7c-1.6,1.1-3.3,1.7-5.1,1.7c-4.3,0-8.9-3.4-8.9-8.9V183.3
	C208.7,177.8,213.4,174.4,217.6,174.4 M217.6,168.4c-7.7,0-14.9,6.1-14.9,14.9v133.5c0,8.8,7.2,14.9,14.9,14.9
	c2.9,0,5.9-0.9,8.6-2.8l92.5-66.7c8.2-5.9,8.2-18.1,0-24.1l-92.5-66.7C223.6,169.3,220.6,168.4,217.6,168.4L217.6,168.4z"
                />
              </svg>
            </div>
            <div
              class="use-details"
              v-lazy-container="{ selector: 'img' }"
              v-html="$options.filters.OSSUrl(useTutorialDetailsData.details)"
            ></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </ContentBox>
  </div>
</template>

<script>
import http from "../../axios/index.js";
import ContentBox from "../../components/content-box.vue";
export default {
  name: "product",
  components: {
    ContentBox,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      productDetail: {
        show: false,
        detail: "",
        title: "",
      },
      videoState: "stop",
      topActiveName: "topFirst", // 顶部选项卡选中的值
      lang: "zh_CN",
      productIndicator: "", // 产品介绍指示点是否显示
      platformIndicator: "", // 平台信息指示点是否显示
      useIndicator: "", // 使用教程指示点是否显示
      productPageSize: 0, // 左边选项卡产品介绍页数
      productLeftActiveName: "", // 左边选项卡产品介绍选中的值
      platformPageSize: 0, // 左边选项卡平台信息页数
      platformLeftActiveName: "", // 左边选项卡平台信息选中的值
      usePageSize: 0, // 左边选项卡使用教程页数
      useLeftActiveName: "", // 左边选项卡使用教程选中的值
      productDescriptionList: [], // 产品介绍数据
      productDetailsData: {}, // 产品介绍详细内容
      productDescriptionTileList: [], // 产品介绍标题
      platformInformationList: [], // 平台信息数据
      platformDetailsData: {}, // 平台信息详细内容
      platformInformationTileList: [], // 平台信息标题
      useTutorialList: [], // 使用教程数据
      useTutorialDetailsData: {}, // 使用教程详细内容
      useTutorialTileList: [], // 使用教程标题
    };
  },
  created() {
    if (this.$route.query.topActiveName) {
      this.topActiveName = this.$route.query.topActiveName;
    }
    if (this.$i18n.locale === "zh") {
      this.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.lang = "en";
    }
    this.getProductDescriptionList(); // 获取产品介绍数据
    this.getPlatformInformationList(); //获取平台资料信息
    this.getUseTutorialList(); // 获取使用教程
  },
  mounted() {
    let that = this;
    this.getMouseWheel();
    let dom = this.$refs.detailsVideo;
    if (dom) {
      dom.addEventListener("playing", function () {
        //播放中
        that.videoState = "play";
        // console.log("播放中");
      });
      dom.addEventListener(
        "ended",
        function () {
          //结束
          that.videoState = "stop";
          dom.controls = false;
          // console.log("播放结束");
        },
        false
      );
    }
  },
  watch: {
    // 监听顶部选项卡值变化
    topActiveName(newVal, oldVal) {
      if (this.topActiveName !== this.$route.query.topActiveName) {
        this.$router.push("/product?topActiveName=" + newVal);
      }
      this.getMouseWheel(); // 指示点绑定滚轮事件
    },
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.lang = "zh_CN";
      } else {
        this.lang = "en";
      }
      this.productDescriptionList = []; // 产品介绍数据
      this.productDetailsData = {}; // 产品介绍详细内容
      this.productDescriptionTileList = []; // 产品介绍标题
      this.platformInformationList = []; // 平台信息数据
      this.platformDetailsData = {}; // 平台信息详细内容
      this.platformInformationTileList = []; // 平台信息标题
      this.useTutorialList = []; // 使用教程数据
      this.useTutorialDetailsData = {}; // 使用教程详细内容
      this.useTutorialTileList = []; // 使用教程标题
      this.getProductDescriptionList(); // 获取产品介绍数据
      this.getPlatformInformationList(); //获取平台资料信息
      this.getUseTutorialList(); // 获取使用教程
    },
  },
  methods: {
    productDetailCancel(data) {
      this.productDetail.show = false;
      this.$refs.detail_content_ref.scrollTo(0, 0);
    },
    // 查看商品详情点击按钮
    productDetailClick(data) {
      const id = data.id;
      this.$router.push("/product?topActiveName=topFirst&topFirstId=" + id);
      this.productDetail.show = true;
      this.productDetail.title = data.productName;
      // 把img的src路径替换成data-src用于v-lazy的懒加载
      if (data.details && !data.details.includes("data-src")) {
        data.details = data.details.replace(/src/g, "data-src");
      }
      this.productDetail.detail = data.details;
      this.videoSrcFilter()
    },
    videoSrcFilter(){
      this.$nextTick(() => {
        let videos=document.querySelectorAll('video')
        for (let i = 0; i < videos.length; i++) {
          if(videos[i].dataset.src){
            videos[i].src=videos[i].dataset.src
          }
        }
      });
    },
    // 商品详情关闭点击事件
    productDetailClose() {
      this.$router.push("/product?topActiveName=topFirst");
    },
    // 显示在线咨询百度统计页面
    onLineClick() {
      let onLineBtn = document.querySelector("#nb_icon_inner_wrap");
      onLineBtn.click();
    },
    // 播放视频
    playVideo() {
      this.videoState = "play";
      this.$refs.detailsVideo.play();
      this.$refs.detailsVideo.controls = true;
    },

    // 指示点绑定滚轮事件
    getMouseWheel() {
      // const dom = document.querySelector(
      //   `.${this.topActiveName} .el-carousel__indicators`
      // );
      // if (dom) {
      //   dom.addEventListener("mousewheel", this.loadingMore, false); // 监听指示点滚轮事件
      // }
      const dom = document.querySelector(
        `.${this.topActiveName} .el-carousel__container`
      );
      if (dom) {
        dom.addEventListener("mousewheel", this.loadingMore, false); // 监听指示点滚轮事件
      }
    },

    // 滚轮事件操作
    loadingMore(e) {
      if (e.deltaY > 0) {
        this.next();
      } else {
        this.prev();
      }
    },
    // 上一张
    prev() {
      this.$refs[`nop${this.topActiveName}`].prev();
    },
    // 下一张
    next() {
      this.$refs[`nop${this.topActiveName}`].next();
    },

    // 顶部选项卡
    topHandleClick(tab, event) {
      // this.$refs.content1.scrollTo(0, 0);
    },

    // 左边选项卡
    leftHandleClick(type) {
      if (type === "topSecond") {
        if (this.$route.query.topSecondName !== this.platformLeftActiveName) {
          this.$router.push(
            "/product?topActiveName=topSecond&topSecondName=" +
              this.platformLeftActiveName
          );
        }
        console.log(this.platformLeftActiveName, "U鱼平台");
      }
      this.$refs.content1.scrollTo(0, 0);
      this.$refs.content2.scrollTo(0, 0);
      this.$refs.content3.scrollTo(0, 0);
      this.getProductDetailsData(); // 得到产品介绍详情数据
      this.getPlatformDetailsData(); // 平台信息详情数据
      this.getUseTutorialDetailsData(); // 使用教程详情数据
    },

    // 处理产品介绍详情数据
    getProductDetailsData() {
      this.productDetailsData =
        this.productDescriptionList.filter(
          (item) => item.productName === this.productLeftActiveName
        )[0] || {};
      // 使用vue-lazyload,所有的img标签的src属性改为data-src
      if (
        this.productDetailsData.details &&
        !this.productDetailsData.details.includes("data-src")
      ) {
        this.productDetailsData.details =
          this.productDetailsData.details.replace(/src/g, "data-src");
      }
    },

    // 处理平台信息详情数据
    getPlatformDetailsData() {
      this.platformDetailsData =
        this.platformInformationList.filter(
          (item) => item.introductionTitle === this.platformLeftActiveName
        )[0] || {};
      // 使用vue-lazyload,所有的img标签的src属性改为data-src
      if (
        this.platformDetailsData.details &&
        !this.platformDetailsData.details.includes("data-src")
      ) {
        this.platformDetailsData.details =
          this.platformDetailsData.details.replace(/src/g, "data-src");
      }
    },

    // 处理使用教程详情数据
    getUseTutorialDetailsData() {
      this.useTutorialDetailsData =
        this.useTutorialList.filter(
          (item) => item.title === this.useLeftActiveName
        )[0] || {};
      // 视频http转https
      if (this.useTutorialDetailsData.detailsVideo) {
        this.useTutorialDetailsData.detailsVideo =
          this.useTutorialDetailsData.detailsVideo.replace(
            "http://",
            "https://"
          );
      }
      // 使用vue-lazyload,所有的img标签的src属性改为data-src
      if (
        this.useTutorialDetailsData.details &&
        !this.useTutorialDetailsData.details.includes("data-src")
      ) {
        this.useTutorialDetailsData.details =
          this.useTutorialDetailsData.details.replace(/src/g, "data-src");
      }
    },

    // 处理产品介绍标题数据
    getProductDescriptionTileList() {
      this.productDescriptionTileList = [];
      const arr = this.productDescriptionList.map((item) => item.productName);
      for (let i = 0; i < this.productPageSize; i++) {
        const pageItem = [];
        pageItem = arr.slice(i * 12, (i + 1) * 12);
        this.productDescriptionTileList.push(pageItem);
      }
    },

    // 处理平台信息标题数据
    getPlatformInformationTileList() {
      this.platformInformationTileList = [];
      const arr = this.platformInformationList.map(
        (item) => item.introductionTitle
      );
      for (let i = 0; i < this.platformPageSize; i++) {
        const pageItem = [];
        pageItem = arr.slice(i * 12, (i + 1) * 12);
        this.platformInformationTileList.push(pageItem);
      }
    },

    // 处理使用教程标题数据
    getUseTutorialTileList() {
      this.useTutorialTileList = [];
      const arr = this.useTutorialList.map((item) => item.title);
      for (let i = 0; i < this.usePageSize; i++) {
        const pageItem = [];
        pageItem = arr.slice(i * 12, (i + 1) * 12);
        this.useTutorialTileList.push(pageItem);
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2021-12-24 17:19:26
     * @description: 获取产品介绍
     * @param {*}
     */
    getProductDescriptionList() {
      const url = `/frontProductDescription/${this.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.productDescriptionList = res.data;
            if (this.productDescriptionList) {
              this.productLeftActiveName =
                this.productDescriptionList[0].productName;
              this.getProductDetailsData(); // 产品介绍详情数据
              this.productPageSize = Math.ceil(
                this.productDescriptionList.length / 12
              );
              this.productPageSize === 1
                ? (this.productIndicator = "none")
                : (this.productIndicator = "");
              this.getProductDescriptionTileList();
            }
            if (
              this.$route.query.topActiveName === "topFirst" &&
              this.$route.query.topFirstId
            ) {
              // console.log("产品介绍页面 且存在产品id的情况");
              const data = this.productDescriptionList.filter((item) => {
                if (item.id === this.$route.query.topFirstId) {
                  return item;
                }
              })[0];
              this.productDetail.show = true;
              this.productDetail.title = data.productName;
              // 把img的src路径替换成data-src用于v-lazy的懒加载
              if (data.details && !data.details.includes("data-src")) {
                data.details = data.details.replace(/src/g, "data-src");
              }
              this.productDetail.detail = data.details;
             this.videoSrcFilter()
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2021-12-27 10:14:55
     * @description: 获取平台资料信息
     * @param {*}
     */
    getPlatformInformationList() {
      const url = `/frontPlatformInformation/${this.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.platformInformationList = res.data;
            if (this.platformInformationList) {
              this.platformLeftActiveName =
                this.platformInformationList[0].introductionTitle;
              // 这里做一层拦截判断 如果存在路由锚点参数 让显示的详情数据为路由锚点数据
              if (this.$route.query.topSecondName) {
                this.platformLeftActiveName = this.$route.query.topSecondName;
              }
              this.getPlatformDetailsData(); // 平台资料详情数据
              this.platformPageSize = Math.ceil(
                this.platformInformationList.length / 12
              );
              this.platformPageSize === 1
                ? (this.platformIndicator = "none")
                : (this.platformIndicator = "");
              this.getPlatformInformationTileList();
            }
          }
        })
        .catch((res) => {
          // console.log(res);
        });
    },
    /**
     * @Author: lishiqiao
     * @Date: 2021-12-27 10:38:17
     * @description: 获取使用教程
     * @param {*}
     */
    getUseTutorialList() {
      const url = `/frontUseTutorial/${this.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.useTutorialList = res.data;
            if (this.useTutorialList) {
              this.useLeftActiveName = this.useTutorialList[0].title;
              this.getUseTutorialDetailsData(); // 使用教程详情数据
              this.usePageSize = Math.ceil(this.useTutorialList.length / 12);
              this.usePageSize === 1
                ? (this.useIndicator = "none")
                : (this.useIndicator = "");
              this.getUseTutorialTileList();
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.product {
  .st0 {
    fill: url(#SVGID_1_);
  }

  width: 100%;
  height: 100%;
  position: relative;

  /deep/.contactus-main {
    width: 116.75rem !important;
  }

  .contactus-content {
    box-sizing: border-box;
    width: 116rem;
    height: 60.6rem;
    background-color: #f0f0f0;

    & > .el-tabs {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 3.5rem;

      /deep/.el-tabs__header {
        .el-tabs__nav-wrap {
          padding: 0.67rem 0;

          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 95.5rem;
            height: 0.08rem;
            background-color: #c5c5c5;
            z-index: 1;
          }

          &::after {
            width: 95.5rem;
            height: 0.08rem;
            background-color: #c5c5c5;
          }

          .el-tabs__nav-scroll {
            // padding: 10px;

            .el-tabs__item {
              width: 31.33rem;
              height: 2.17rem;
              line-height: 2.17rem;
              background: #c5c5c5;
              padding: 0;
              font-size: 1.5rem;
              //font-family: Alibaba PuHuiTi;
              font-family: AlibabaPuHuiTi-Regular;
              font-weight: 400;
              color: #7e7e7e;
              text-align: center;
              transition: none;
              border-bottom: none;

              &:nth-child(3) {
                margin: 0 0.75rem;
              }
            }

            .is-active {
              background: #07b8f9;
              color: #ffffff;
            }

            .el-tabs__active-bar {
              display: none;
            }
          }
        }
      }
      // 主体
      /deep/.el-tabs__content {
        width: 100%;
        .el-tab-pane {
          width: 116.75rem;
          height: auto;
          margin-top: 5.58rem;
          display: flex;

          .el-carousel {
            width: 18.5rem;
            height: 40rem;
            overflow: visible;

            .el-carousel__container {
              overflow: hidden;
              height: 100%;

              .el-carousel__item {
                display: none;

                .el-tabs {
                  height: 100%;

                  .el-tabs__header {
                    width: 100%;

                    .el-tabs__nav-wrap {
                      margin-right: 0;
                      padding: 0;

                      &::before {
                        width: 0;
                        height: 0;
                      }

                      &::after {
                        width: 0;
                        height: 0;
                      }

                      .el-tabs__item {
                        box-sizing: border-box;
                        padding: 0;
                        padding-top: 1rem;
                        padding-left: 2.75rem;
                        width: 100%;
                        height: 3.33rem;
                        line-height: 1.33rem;
                        font-size: 1.33rem;
                        //font-family: Alibaba PuHuiTi;
                        font-family: AlibabaPuHuiTi-Regular;
                        font-weight: 400;
                        color: #8e8e8e;
                        text-align: left;
                        background: transparent;
                        border-top: 0.08rem solid #d9d9d9;
                        border-bottom: none;

                        &:nth-child(3) {
                          margin: 0;
                        }

                        &:last-child {
                          border-bottom: 0.08rem solid #d9d9d9;
                        }
                      }

                      .el-tabs__active-bar {
                        display: none;
                      }

                      .is-active {
                        background: #07b8f9;
                        border-radius: 0rem 2rem 2rem 0rem;
                        color: #fefefe;
                      }
                    }
                  }
                }
              }

              .is-active {
                display: block;
              }
            }

            .el-carousel__indicators {
              height: 1.33rem;
              top: -2.75rem;
              left: 0;
              transform: translateX(0);
              margin-left: 2.75rem;
              cursor: pointer;

              .el-carousel__indicator {
                padding: 0;
                margin-right: 1.25rem;

                &:last-child {
                  margin-right: 0;
                }

                .el-carousel__button {
                  width: 1.3rem;
                  height: 1.33rem;
                  background: #c5c5c5;
                  border-radius: 50%;
                  opacity: 1;
                }
              }

              .is-active {
                .el-carousel__button {
                  background: #07b8f9;
                }
              }
            }
          }

          .product-content {
            box-sizing: border-box;
            width: 83.08rem;
            height: 39.42rem;
            border-radius: 1rem;
            margin-left: 13rem;
            overflow-y: auto;
            padding: 1rem;
            padding-right: 26.33rem;
            margin-top: -1rem;
            font-size: 1.17rem;
            //font-family: Alibaba PuHuiTi;
            font-family: AlibabaPuHuiTi-Medium;
            font-weight: 500;
            color: #2b2b2b;
            line-height: 2rem;

            &::-webkit-scrollbar {
              width: 1.17rem;
            }

            &::-webkit-scrollbar-thumb {
              background: #929292;
            }

            &::-webkit-scrollbar-track {
              background: #d9d9d9;
            }

            p {
              span {
                display: inline-block;
                text-align: justify;
              }

              img {
                width: 55.58rem;
                height: 39.42rem;
              }
            }
          }
          .product_introduce_content {
            padding: 0 10rem;
            box-sizing: border-box;
            margin: 0 auto;
            width: 94.5%;
            height: auto;
            max-height: 40rem;
            overflow-y: scroll;
            display: flex;
            flex-wrap: wrap;
            .product_item_content {
              width: 25.83rem;
              height: 18.33rem;
              margin-left: 5.17rem;
              margin-bottom: 3.08rem;

              &:nth-child(3n + 1) {
                margin-left: unset;
              }
              .product_img {
                position: relative;
                width: 100%;
                height: 15rem;
                background: rgba(255, 255, 255, 0.45);
                border: 0.1rem solid #c5c5c5;
                border-radius: 0.83rem;
                margin-bottom: 1.25rem;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                }
                .img_detail_click {
                  white-space: nowrap;
                  font-size: 1.17rem;
                  cursor: pointer;
                  box-sizing: border-box;
                  border: 0.08rem solid #7e7e7e;
                  border-radius: 1.2rem;
                  padding: 0 0.8rem;
                  color: #7e7e7e;
                  z-index: 10;
                  bottom: 1.33rem;
                  text-align: center;
                  line-height: 2.17rem;
                  left: 2.25rem;
                  height: 2.17rem;
                  position: absolute;
                }
              }

              .product_btn {
                cursor: pointer;
                width: 100%;
                height: 2rem;
                line-height: 2rem;
                font-size: 1.4rem;
                text-align: center;
                padding: 0.3rem 0;
                color: white;
                background: linear-gradient(94deg, #06baf9 0%, #0b97f3 100%);
                box-shadow: 0 0.17rem 0.58rem 0px rgba(6, 167, 226, 0.25);
                border-radius: 1.2rem;
              }
            }
          }
        }
        .topSecond {
          .product-content {
            width: 95.08rem;
            height: 34.5rem;
            margin: 0;
            padding: 0;

            .product-box {
              box-sizing: border-box;
              height: inherit;
              padding-left: 2rem;
              padding-right: 7.33rem;
              padding-top: 3.66rem;

              .product-img {
                width: 100%;
                display: flex;
                margin-bottom: 3.08rem;
                justify-content: space-between;

                img {
                  width: 41.19rem;
                  height: 22.78rem;
                  border-radius: 1rem;
                  padding-top: 0.5rem;
                }
              }

              .product-details {
                width: 100%;
              }
            }
          }
        }
        .topThird {
          .product-content {
            width: 85.33rem;
            height: 41rem;
            margin: 0;
            padding: 0;
            margin-left: 10.75rem;
            .use-detailsVideo {
              width: 72.83rem;
              height: 41rem;
              border-radius: 1rem;
              position: relative;
              video {
                width: 100%;
                height: 100%;
              }
              svg {
                position: absolute;
                width: 9.73rem;
                height: 9.73rem;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
              .video-play {
                width: 0;
                height: 0;
              }
              .video-stop {
                width: 9.73rem;
                height: 9.73rem;
              }
            }
            .use-details {
              width: 72.83rem;
              p {
                display: flex;
                flex-direction: column;
                align-items: center;
              }
            }
          }
        }
      }
    }
  }
  .news-detail-box {
    .new-detail-main {
      box-sizing: border-box;
      padding-top: 1rem;
      padding-bottom: 10rem;
      height: 100%;
      padding-right: 2rem;
      .out-detail {
        // position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 2rem;
        font-size: 40px;
        text-align: center;
        margin-bottom: 3rem;

        .release-time {
          text-align: center;
          font-size: 1rem;
          // font-family: Alibaba PuHuiTi;
          font-family: Alibaba-PuHuiTi-Medium;
          font-weight: 500;
          letter-spacing: 0.2rem;
          color: #2b2b2b;
        }

        .out-img-box {
          margin-right: -0.5rem;
          width: 100px;
          height: 100px;
          float: right;
          cursor: pointer;

          .st0 {
            fill: #ffffff;
          }
        }
      }
      /deep/.detail_box {
        max-height: 50rem;
        .detail-content {
          overflow-y: scroll;
          box-sizing: border-box;
          overflow: auto;
          width: 100%;
          max-height: 40rem;
          padding-right: 19.5rem;
          padding-left: 22.83rem;
          font-size: 1.17rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2b2b2b;
          letter-spacing: 0.2rem;
          img {
            width: 55.58rem;
            height: 39.42rem;
          }

          video {
            width: 55.58rem;
            height: 39.42rem;
          }
        }
        .product_btn {
          margin: 3rem auto;
          cursor: pointer;
          width: 16.42rem;
          height: 3rem;
          line-height: 3rem;
          font-size: 1.4rem;
          text-align: center;
          padding: 0.3rem 0;
          color: white;
          background: linear-gradient(94deg, #06baf9 0%, #0b97f3 100%);
          box-shadow: 0 0.17rem 0.58rem 0px rgba(6, 167, 226, 0.25);
          border-radius: 1.7rem;
        }
      }
    }
  }
}
</style>
